import { Grid, Stack } from '@mui/material'

interface MapControlLayoutProps {
  upperLeft?: any
  upperRight?: any
  lowerLeft?: any
  lowerRight?: any
}

export const MapControlLayout = ({
  upperLeft,
  upperRight,
  lowerLeft,
  lowerRight,
}: MapControlLayoutProps) => (
  <Stack
    direction="column"
    justifyContent="space-between"
    sx={{ position: 'relative', flex: 1, pointerEvents: 'none', height: '100%' }}
  >
    <Grid sx={{ padding: 2, paddingBottom: 5 }} container>
      <Grid xs={!!upperRight ? 8 : 12} item style={{ pointerEvents: 'none' }}>
        {!!upperLeft && upperLeft}
      </Grid>

      <Grid xs={4} item style={{ pointerEvents: 'none' }}>
        {!!upperRight && upperRight}
      </Grid>
    </Grid>
    <Grid sx={{ padding: 2, paddingBottom: 5 }} justifyContent="space-between" container>
      <Grid xs={3} alignItems="flex-end" container item>
        <Stack spacing={2} style={{ pointerEvents: 'all' }}>
          {!!lowerLeft && lowerLeft}
        </Stack>
      </Grid>
      <Grid xs={3} alignItems="flex-end" justifyContent="flex-end" container item>
        <div style={{ pointerEvents: 'all' }}>{!!lowerRight && lowerRight}</div>
      </Grid>
    </Grid>
  </Stack>
)
